var fun = {
  //小数点后末尾去零
  cutZero(old){
    //拷贝一份 返回去掉零的新串
    let newstr=old;
    //循环变量 小数部分长度
    let leng = old.length-old.indexOf(".")-1
    //判断是否有效数
    if(old.indexOf(".")>-1){
      //循环小数部分
      for(let i = leng; i > 0; i--){
        //如果newstr末尾有0
        if(newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length-1,1) == 0){
          var k = newstr.lastIndexOf("0");
          //如果小数点后只有一个0 去掉小数点
          if(newstr.charAt(k-1)=="."){
            return  newstr.substring(0,k-1);
          }else{
            //否则 去掉一个0
            newstr=newstr.substring(0,k);
          }
        }else{
          //如果末尾没有0
          return newstr;
        }
      }
    }
    return old;
  },
  throttle: function(fn, interval) {
    console.log(565656)
    var enterTime = 0
    var gapTime = interval || 300
    return function() {
      var context = this
      var backTime = new Date()
      if (backTime - enterTime > gapTime) {
        fn.call(context,arguments[0])
        enterTime = backTime
      }
    }
  },
  debounce: function(fn, interval) {  //防抖
    var timer
    var gapTime = interval || 1000
    return function () {
      clearTimeout(timer)
      var context = this
      let args = arguments[0]
      timer = setTimeout(function () {
        fn.call(context, args)
      }, gapTime)
    }
  },
  indexofimg: function(img) {
    return img.indexOf('https://') == -1?process.env.VUE_APP_STATIC_URL + img:img
  },
  getNowFormatDate: function(time) {
    var date = new Date(time);
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getUrl: function (name, params, query) {
    query = R.mergeAll([query, {
      i: this.getKeyByI()
    }])
    return {
      name,
      params,
      query
    }
  },
  getCookie:function(){
    if(!document.cookie) return ''
    if(!document.cookie.includes('token')) return ''
    let cookies = document.cookie.split(/[;= ]/)
    let indexOf4 = (cookies || []).findIndex((item) => item === 'token')
    return cookies[indexOf4+1]
  },
  getKey:function (name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
  },
  getReplce: function (){
    if(this.getKeyByMid()){
      if(location.href.indexOf("&mid=") != -1){
        var urlName = "&mid=" + this.getKeyByMid()
      }else if(location.href.indexOf("?mid=") != -1){
        var urlName = "mid=" + this.getKeyByMid() + '&'
      }
      return location.href.replace(urlName,"")
    }else {
      return location.href
    }
  },
  getKeyByI: function () {
    let i = this.getKey('i')
    return i
  },
  getKeyBySpid: function () {
    let spid = this.getKey('spid')
    return spid
  },
  isMid: function (url, val) {
    let arg = 'mid'
    if (!val){
      return url
    }
    if (url.indexOf("mid=") >= 0) {
      return this.changeUrlArg(url, 'mid', val)
    } else {
      let burl = this.delQueStr(url, 'mid')
      return this.changeUrlArg(burl, 'mid', val)
    }
  },
  changeUrlArg: function (url, arg, val) {
    var pattern = arg + '=([^&]*)'
    var replaceText = arg + '=' + val
    var splitUrl = url.split('#')
    return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? splitUrl[0] + '&' + replaceText + "#"+splitUrl[1] : splitUrl[0] + '?' + replaceText + "#"+splitUrl[1]);
  },
  //删除参数值
  delQueStr: function (url, ref) {
    var str = ""
    if (url.indexOf('#') != -1) {
      str = url.substr(url.indexOf('#') + 1)
    } else {
      return url
    }
    var arr = ""
    var returnurl = ""
    var setparam = ""
    if (str.indexOf('&') != -1) {
      arr = str.split('&')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].split('=')[0] != ref) {
          returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&"
        }
      }
      return url.substr(0, url.indexOf('?')) + "?#" + returnurl.substr(0, returnurl.length - 1)
    } else {
      arr = str.split('=')
      if (arr[0] == ref)
        return url.substr(0, url.indexOf('?'))
      else
        return url
    }
  },
}
export default fun



// WEBPACK FOOTER //
// ./src/utils/fun.js